@if (isBrandingReady) {
  @if (showHeader) {
    <div class="main-layout-container">
      <app-menu-global></app-menu-global>
      <div class="main-content-wrapper">
        <app-header-global></app-header-global>

        @if (showActions) {
          <div class="buttons-action-container">
            <app-table-actions></app-table-actions>
          </div>
        }

        <app-main-global>
          <router-outlet/>
        </app-main-global>
      </div>
    </div>
  }

  @if (!showHeader) {
    <router-outlet/>
  }

  <!-- Container per le modali -->
  <ng-container #modalContainer></ng-container>
}

<app-loader></app-loader>
<app-toast></app-toast>
